module.exports = __webpack_public_path__ + "img/emoji_08.f4ac9bee.png";